(() => {
  class RejectMailOrderRefillController {
    constructor($rootScope, $scope, $timeout, $interval, toastr, $state, ngDialog) {
      'ngInject';

      Object.assign(this, {
        $scope,
        $rootScope,
        $timeout,
        $interval,
        toastr,
        $state,
        ngDialog
      });
    }

    close() {
      this.$scope.closeThisDialog(false);
    }

    sendFillRequest() {
      this.$scope.closeThisDialog(true);
    }

  }

  RejectMailOrderRefillController.$inject = ["$rootScope", "$scope", "$timeout", "$interval", "toastr", "$state", "ngDialog"];
  angular.module('pims').controller('RejectMailOrderRefillController', RejectMailOrderRefillController);
})();